// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F7jUT","left":"styles_left__2UICp"};